import { useCallback } from 'react';

export const usePublishEditPayeeSuccessEvent = () =>
  useCallback(() => {
    window.dispatchEvent(
      new CustomEvent('edit-payee-success', {
        bubbles: true,
        detail: { success: true },
      })
    );
  }, []);
